import { Component, OnInit, Input, HostListener } from '@angular/core';
import { Options } from '../options/options.component';
import { Toggler } from 'projects/exi-ui/src/lib/utils/toggler.class';
import { map } from 'rxjs/operators';
import { Drop, Fade as Fade } from 'projects/exi-ui/src/lib/animations/animations';

@Component({
   selector: 'app-dropdown',
   styleUrls: ['./dropdown.component.scss'],
   animations: [Drop, Fade],
   template: `
      <div class="conrol">
         <div class="current">{{ ctx.title(ctx.current()) || ctx.placeholder }}</div>
         <button class="opener" (click)="toggler.toggle()">+</button>
      </div>
      
      <app-options [ctx]="ctx" *ngIf="toggler.state === 'opened'" @Fade></app-options>
   `,
})
export class DropdownComponent implements OnInit {
   @Input() public ctx: Dropdown<object>;
   public toggler = new Toggler();

   constructor() { }

   ngOnInit() {
      const old = this.ctx.select;
      
      this.ctx.select = option => {
         this.toggler.close();
         if (this.ctx.deselectValue && (this.ctx.current() === option || (option as any).title === 'None')) {
            old(this.ctx.deselectValue());
         } else {
            old(option);
         }
      }
   }
}

export interface Dropdown<D extends object> extends Options<D> {
   current: () => D;
   placeholder: string;
   deselectValue: () => D;
}